module.exports = __webpack_public_path__ + "img/2.2e413899.webp";